import type { Building } from "building-types/building/buildingTypes";
import type { Casework } from "building-types/casework/caseworkTypes";
import type { GeneratedMeasurement } from "building-types/entities/measurementTypes";
import type {
  CaseworkHandle,
  MeasurementHandle,
  PropInstanceHandle,
  RoofHandle,
  RoomHandle,
} from "building-types/handles/docEntityHandleTypes";
import type { Prop } from "building-types/props/propTypes";
import type { GeneratedRoof } from "building-types/roofs/generatedRoofSystemTypes";
import type { Room } from "building-types/rooms/roomTypes";
import type { WallIndex } from "building-types/walls/wallIndex";

export function propFromWallPropHandle(bldg: Building, handle: PropInstanceHandle): Prop | undefined {
  for (const propId in bldg.props) {
    const prop = bldg.props[propId];
    if (prop.handle?.id === handle.id) {
      return prop;
    }
  }
  return undefined;
}

export function caseworkFromWallCaseworkHandle(bldg: Building, handle: CaseworkHandle): Casework | undefined {
  for (const caseworkId in bldg.casework) {
    const casework = bldg.casework[caseworkId];
    if (casework.handle?.id === handle.id) {
      return casework;
    }
  }
  return undefined;
}

export function wallIndexForLevel(bldg: Pick<Building, "walls">, levelId: string): WallIndex {
  return bldg.walls[levelId].wallIndex;
}

export function roomFromRoomHandle(bldg: Building | undefined | null, handle: RoomHandle): Room | undefined {
  return bldg?.rooms[handle?.id];
}

export function measurementFromMeasurementHandle(bldg: Building, handle: MeasurementHandle): GeneratedMeasurement {
  return bldg?.measurements[handle?.id];
}

export function multiGableRoofFromRoofHandle(bldg: Building, handle: RoofHandle): GeneratedRoof | undefined {
  for (const roofId in bldg?.roofSystems) {
    const roofSystem = bldg.roofSystems[roofId];

    const { roofs: subRoofs } = roofSystem;
    for (const subRoofId in subRoofs) {
      const generatedRoof = subRoofs[subRoofId];
      if (generatedRoof.id === handle.id) {
        return generatedRoof;
      }
    }
  }

  return undefined;
}
